import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { LoginFormModule } from '@libs/src/login-form/login-form.module';
import { LocalizationDropDownModule } from '@main-client/src/app/localization-drop-down/localization-drop-down.module';
import { NoLocalStoragePromptModule } from '@main-client/src/app/no-local-storage-prompt/no-local-storage-prompt.module';
import { OnboardingBackgroundFlairModule } from '@main-client/src/app/onboarding-background-flair/onboarding-background-flair.module';
import { LiveTranslateModule } from '@main-client/src/app/pipes/live-translate/live-translate.module';
import { ProgressSpinnerModule } from '@main-client/src/app/progress-spinner/progress-spinner.module';

import { LoginViewComponent } from './login-view.component';

@NgModule({
  declarations: [LoginViewComponent],
  imports: [
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    LiveTranslateModule,
    LocalizationDropDownModule,
    LoginFormModule,
    MatButtonModule,
    MatIconModule,
    NoLocalStoragePromptModule,
    RouterModule.forChild([
      {
        component: LoginViewComponent,
        path: '',
      },
    ]),
    OnboardingBackgroundFlairModule,
    ProgressSpinnerModule,
  ],
})
export class LoginModule {}
